// Capture & persist UTM + click-ids (fbclid, gclid) for attribution
// across the OTP / Razorpay flow. Reads from URL on first hit, saves to LS,
// and exposes them as a single object for analytics events.

const LS_KEY = "autohq_attribution";

const ATTR_KEYS = [
  "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
  "gclid", "fbclid", "gbraid", "wbraid",
];

export function captureAttribution() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const fresh = {};
  ATTR_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) fresh[k] = v;
  });
  let saved = {};
  try { saved = JSON.parse(localStorage.getItem(LS_KEY) || "{}"); } catch { /* ignore */ }
  // First-touch attribution: keep oldest UTMs, but always update click-ids
  const merged = { ...fresh, ...saved, landing: saved.landing || window.location.pathname, first_seen: saved.first_seen || new Date().toISOString() };
  // Override click-ids with latest if present (last-click for ad networks)
  ["gclid", "fbclid", "gbraid", "wbraid"].forEach((k) => { if (fresh[k]) merged[k] = fresh[k]; });
  localStorage.setItem(LS_KEY, JSON.stringify(merged));
  return merged;
}

export function getAttribution() {
  if (typeof window === "undefined") return {};
  try { return JSON.parse(localStorage.getItem(LS_KEY) || "{}"); } catch { return {}; }
}
